import {
  FormControlLabel,
  Grid,
  Switch,
  TableCell,
  Typography,
} from "@material-ui/core"
import { SubscriptionList } from "@root/store/types"
import { Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import React from "react"
import { SCOPES } from "./Subscriptions"

export interface Props {
  list: SubscriptionList
  onAddList: (listId: string, scope: Scope) => void
  onRemoveList: (listId: string, scope: Scope) => void
}

const ScopedListItem: React.FC<Props> = ({ list, onAddList, onRemoveList }) => {
  return (
    <>
      <TableCell component="th" scope="row">
        {list.id}
      </TableCell>
      <TableCell>
        <Grid container>
          {SCOPES.map((scope) => (
            <Grid item key={`${list.id}.${scope}`} xs={12} md={3}>
              <FormControlLabel
                control={
                  <Switch
                    data-qa-selector={`preference-center-subscription-${list.id}-checkbox`}
                    checked={Boolean(list.scopes?.includes(scope))}
                    onChange={(ev) => {
                      if (ev.target.checked) {
                        onAddList(list.id, scope)
                      } else {
                        onRemoveList(list.id, scope)
                      }
                    }}
                    name={list.id}
                    color="primary"
                  />
                }
                label={
                  <>
                    <Typography variant="body1">{scope}</Typography>
                  </>
                }
              />
            </Grid>
          ))}
        </Grid>
      </TableCell>
    </>
  )
}

export default ScopedListItem
